// Shared Recharts theme so every chart in the app is on-brand and consistent.
// Colors resolve from the CSS design tokens (see index.css) at import time,
// so light/dark and any future token change flow through automatically.

const cssVar = (name, fallback) => {
  if (typeof window === 'undefined') return fallback;
  const v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  return v ? `hsl(${v})` : fallback;
};

// Ordered categorical palette (indigo → cyan → teal → green → amber → slate).
export const CHART_COLORS = [
  '#3b4fb8', // indigo — brand primary
  '#0EA5E9', // info / cyan
  '#1f9e8f', // teal — violet sat too close to the indigo to read as separate
  '#16A34A', // success
  '#F59E0B', // warning
  '#64748B', // slate
  '#DC2626', // danger
  '#0891B2', // teal
];

export const chartColor = (i) => CHART_COLORS[i % CHART_COLORS.length];

// Semantic colors for status-driven series.
export const STATUS_COLORS = {
  present: '#16A34A',
  absent: '#DC2626',
  late: '#F59E0B',
  leave: '#0EA5E9',
  wfh: '#7C3AED',
  pending: '#F59E0B',
  approved: '#16A34A',
  rejected: '#DC2626',
  active: '#16A34A',
  inactive: '#64748B',
};

// Common axis props for a calm, minimal look. Token-driven so axes/labels
// stay legible in both light and dark themes.
export const axisProps = {
  tick: { fontSize: 12, fill: 'hsl(var(--muted-foreground))' },
  tickLine: false,
  axisLine: { stroke: 'hsl(var(--border))' },
};

export const gridProps = {
  strokeDasharray: '3 3',
  stroke: 'hsl(var(--border))',
  vertical: false,
};

// Premium tooltip style — theme-aware surface so tooltips read correctly in
// dark mode too (used via <Tooltip contentStyle={tooltipContentStyle} .../>).
export const tooltipContentStyle = {
  borderRadius: '12px',
  border: '1px solid hsl(var(--border))',
  background: 'hsl(var(--card))',
  color: 'hsl(var(--foreground))',
  boxShadow: '0 8px 24px -8px hsl(222 47% 11% / 0.18)',
  fontSize: '12px',
  padding: '8px 12px',
};

export const tooltipCursor = { fill: 'hsl(var(--primary) / 0.06)' };

// Helper to build an SVG linear-gradient <defs> id + stops for area charts.
export const areaGradient = (id, color = '#3b4fb8') => ({ id, color });

export { cssVar };
